import { STAGE_ORDER, type Stage } from "@/components/tablero/types";
import type { PipelinePosition } from "@/contexts/PipelineContext";

/**
 * Etapa options for the conversation panel: every position except the system
 * "discarded" one, in board order.
 *
 * Includes "inactive" — it is not a column on the default board (it has its own
 * tab) but it is a valid manual destination, and it is the current position of
 * every lead opened from the Inactivos funnel. The tablero used to reach this
 * same set by filtering "inactive" out for the board and adding it back for the
 * drawer; stating the rule once here keeps the two surfaces from drifting.
 */
export const conversationPanelPositions = (all: PipelinePosition[]): PipelinePosition[] =>
  [...all]
    .filter((p) => p.id !== "discarded")
    .sort(
      (a, b) =>
        STAGE_ORDER.indexOf(a.stage as Stage) - STAGE_ORDER.indexOf(b.stage as Stage) ||
        a.order - b.order
    );
